import { render, staticRenderFns } from "./WorkCat.vue?vue&type=template&id=c37be906&scoped=true&"
import script from "./WorkCat.vue?vue&type=script&lang=js&"
export * from "./WorkCat.vue?vue&type=script&lang=js&"
import style0 from "./WorkCat.vue?vue&type=style&index=0&id=c37be906&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37be906",
  null
  
)

export default component.exports